import { render, staticRenderFns } from "./PasoDosInvitaciones.vue?vue&type=template&id=a849e0d8"
import script from "./PasoDosInvitaciones.vue?vue&type=script&lang=js"
export * from "./PasoDosInvitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports